





















































import {Component, Vue} from "vue-property-decorator";
import {Getter, Mutation} from "vuex-class";
import axios from "axios";
import moment from "moment";

interface Dataset {
    id: number;
    name: string;
}

interface Report {
    name: string;
    dataset?: number;
    content?: string;
}

@Component({
    components: {
    }
})

export default class NewReportView extends Vue {


    name= "NewReportView";
    dataLoaded = false;
    report ?: Report = {
        name: "",
        content: undefined,
    };

    allDatasets: Dataset[] = []

    // map getters
    @Getter base_url !: any;
    @Getter auth_header !: any;

    @Mutation SET_BREADCRUMB!: (_ : any) => any; //TODO: add type

    mounted () {
        this.setBreadcrumb();

        axios
            .get(`${this.base_url}${'experiments/datasets'}?archived=False`, {
                headers: this.auth_header
            })
            .then(response => {
                this.allDatasets = response.data;
                console.log("datasets json: ")
                console.log(this.allDatasets)
            })
            .catch(error => {
                console.log("Something went wrong getting the ExperimentalDatasets : ", error.response.data);
            });


    }

    saveReport(){
        axios
            .post(
                this.base_url + 'experiments/reports',
                this.report,
                {
                    headers: this.auth_header
                }
            )
            .then(response => {
                console.log("Report Successfully Created", response);
                this.$router.push({ name: "EditReportView", params: { id: ""+response.data.id } });
            })
            .catch(error => {
            });
    }

    //original methods
    setBreadcrumb(){
        this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
    }
}
